import { NavLink, Route, Routes } from 'react-router-dom';
import { BRAND, LOCALE_LABELS, type Locale } from '@sb2/shared';
import { LocaleProvider, useLocale } from '../i18n/LocaleContext';
import { AuthProvider, useAuth } from './AuthContext';
import { NameGate } from './components/NameGate';
import { HomePage } from './pages/HomePage';
import { SoloPage } from './pages/SoloPage';
import { LobbyPage } from './pages/LobbyPage';
import { ProfilePage } from './pages/ProfilePage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { AdminPage } from './pages/AdminPage';

export function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </LocaleProvider>
  );
}

function Shell() {
  const { user } = useAuth();
  const { t, locale, setLocale } = useLocale();
  return (
    <div className="app-shell">
      <header className="topbar">
        <NavLink to="/" className="brand" aria-label={BRAND.name}>
          <span className="brand-name">{BRAND.name}</span>
        </NavLink>
        <nav className="nav">
          <NavLink to="/solo">{t('navSolo')}</NavLink>
          <NavLink to="/lobby">{t('navMultiplayer')}</NavLink>
          <NavLink to="/profile">{t('navProfile')}</NavLink>
          <NavLink to="/leaderboard">{t('navLeaderboard')}</NavLink>
          {user?.isAdmin ? <NavLink to="/admin">{t('navAdmin')}</NavLink> : null}
        </nav>
        <div className="topbar-right">
          <label className="lang-switch">
            <span className="sr-only">{t('settingsLanguage')}</span>
            <select
              value={locale}
              onChange={(e) => setLocale(e.target.value as Locale)}
              aria-label={t('settingsLanguage')}
            >
              {(Object.keys(LOCALE_LABELS) as Locale[]).map((code) => (
                <option key={code} value={code}>
                  {LOCALE_LABELS[code]}
                </option>
              ))}
            </select>
          </label>
          <UserChip />
        </div>
      </header>
      <main className="main">
        <NameGate>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solo" element={<SoloPage />} />
            <Route path="/lobby" element={<LobbyPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/settings" element={<HomePage />} />
          </Routes>
        </NameGate>
      </main>
      <footer className="footer">{t('footerNote')}</footer>
    </div>
  );
}

function UserChip() {
  const { user, loading } = useAuth();
  const { t } = useLocale();
  if (loading) return <span className="badge">…</span>;
  if (!user) return <span className="badge">{t('signedOut')}</span>;
  return (
    <span className="badge">
      {user.username ?? t('guest')}
      {user.isAdmin ? ` · ${t('admin')}` : ''}
    </span>
  );
}
